var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMsLogo = function SvgMsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f25022",
    d: "M1 1h9v9H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a4ef",
    d: "M1 11h9v9H1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fba00",
    d: "M11 1h9v9h-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb900",
    d: "M11 11h9v9h-9z"
  })));
};
export { SvgMsLogo as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3e%3ctitle%3eMS-SymbolLockup%3c/title%3e%3crect x='1' y='1' width='9' height='9' fill='%23f25022'/%3e%3crect x='1' y='11' width='9' height='9' fill='%2300a4ef'/%3e%3crect x='11' y='1' width='9' height='9' fill='%237fba00'/%3e%3crect x='11' y='11' width='9' height='9' fill='%23ffb900'/%3e%3c/svg%3e";